export const SETTINGS = {
  KYC_MAX_RETRIES: 1,
  MANUAL_KYC_INTERVAL: 3, // days
}

export const SUBSTITUTE_DOMAINS = {
  staging1: "eastwesteducationalspecialist",
  localhost: "learnphiltax",
}

export const GOOGLE_SITE_KEY = process.env.REACT_APP_GOOGLE_SITE_KEY
export const MAGPIE_PUBLIC_KEY = process.env.REACT_APP_MAGPIE_PUBLIC_KEY
export const FACEBOOK_APP_KEY = process.env.REACT_APP_FACEBOOK_KEY
export const GOOGLE_APP_KEY = process.env.REACT_APP_GOOGLE_KEY
export const GOOGLE_ANALYTICS_KEY = process.env.REACT_APP_GA_TRACKING
export const INFURA_ID = process.env.REACT_APP_INFURA_ID
export const CURRENT_ENV = process.env.REACT_APP_ENVIRONMENT
export const WALLET_PROVIDER = process.env.REACT_APP_PROVIDER

export const NETWORKS = {
  localhost: {
    name: "localhost",
    color: "#666666",
    chainId: 31337,
    blockExplorer: "",
    rpcUrl: "http://" + window.location.hostname + ":8545",
  },
  mainnet: {
    name: "mainnet",
    color: "#ff8b9e",
    chainId: 1,
    rpcUrl: `https://mainnet.infura.io/v3/${INFURA_ID}`,
    blockExplorer: "https://etherscan.io/",
  },
  kovan: {
    name: "kovan",
    color: "#7003DD",
    chainId: 42,
    rpcUrl: `https://kovan.infura.io/v3/${INFURA_ID}`,
    blockExplorer: "https://kovan.etherscan.io/",
    faucet: "https://gitter.im/kovan-testnet/faucet", // https://faucet.kovan.network/
  },
  rinkeby: {
    name: "rinkeby",
    color: "#e0d068",
    chainId: 4,
    rpcUrl: `https://rinkeby.infura.io/v3/${INFURA_ID}`,
    faucet: "https://faucet.rinkeby.io/",
    blockExplorer: "https://rinkeby.etherscan.io/",
  },
  ropsten: {
    name: "ropsten",
    color: "#F60D09",
    chainId: 3,
    faucet: "https://faucet.ropsten.be/",
    blockExplorer: "https://ropsten.etherscan.io/",
    rpcUrl: `https://ropsten.infura.io/v3/${INFURA_ID}`,
  },
  goerli: {
    name: "goerli",
    color: "#0975F6",
    chainId: 5,
    faucet: "https://goerli-faucet.slock.it/",
    blockExplorer: "https://goerli.etherscan.io/",
    rpcUrl: `https://goerli.infura.io/v3/${INFURA_ID}`,
  },
}

export const NETWORK = (chainId) => {
  for (const n in NETWORKS) {
    if (NETWORKS[n].chainId === chainId) {
      return NETWORKS[n]
    }
  }
}

export const FAQS_LINK = {
  "school-522": "/faqs-522.html",
}

export const MANUAL_PAYMENT_MODES = ["cash", "otc_bank", "others"]

export const APT_COIN_RATE = 1
